import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class BusyService {
  busyRequestCount = 0;
  private hideTimeout: any;

  constructor(private spinnerService: NgxSpinnerService) { }

  busy() {
    if (this.busyRequestCount < 0) {
      this.busyRequestCount = 0;
    }
    this.busyRequestCount++;

    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    // Always trigger spinner show when busyRequestCount > 0
    setTimeout(() => {
      if (this.busyRequestCount > 0) {
        this.spinnerService.show(undefined, {
          type: 'ball-circus',
          bdColor: 'rgba(0,0,0,0.4)',
          color: '#ffc107',
          size: "medium"
        });
      }
    }, 0);
  }

  idle() {
    this.busyRequestCount--;
    if (this.busyRequestCount <= 0) {
      this.busyRequestCount = 0;
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.spinnerService.hide();
    }
  }

  reset() {
    this.busyRequestCount = 0;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    this.spinnerService.hide();
  }
}
